import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const Shell = ({ children }) => <div className="flex min-h-screen items-center justify-center bg-[#F6F7F4] p-6"><div className="ka-card max-w-md p-10 text-center ka-fade">{children}</div></div>;
const Back = () => <Link data-testid="payment-back-link" to="/app/billing" className="ka-press mt-6 inline-block rounded-full bg-slate-950 px-6 py-3 text-sm font-semibold text-white">Back to billing</Link>;

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch (e) {
        return setState("failed");
      }
      if (++tries < 10) timer = setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);
  return (
    <Shell>
      {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-emerald-600" /><h1 className="mt-4 text-2xl font-extrabold">Confirming payment…</h1></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" /><h1 data-testid="payment-success-title" className="mt-4 text-2xl font-extrabold">You're subscribed</h1><p className="mt-2 text-slate-600">Thanks — your venues are now on an active plan.</p></>}
      {state === "pending" && <><h1 className="text-2xl font-extrabold">Still processing</h1><p className="mt-2 text-slate-600">We'll update your billing status once Stripe confirms.</p></>}
      {state === "failed" && <><XCircle className="mx-auto h-12 w-12 text-rose-600" /><h1 className="mt-4 text-2xl font-extrabold">Payment not completed</h1></>}
      <Back />
    </Shell>
  );
}

export function PaymentCancel() {
  return <Shell><XCircle className="mx-auto h-12 w-12 text-slate-400" /><h1 data-testid="payment-cancel-title" className="mt-4 text-2xl font-extrabold">Checkout cancelled</h1><p className="mt-2 text-slate-600">No payment was taken.</p><Back /></Shell>;
}
